import React, { useReducer } from 'react'
import petContext from '@/contexts/petContext'
import List from '@/views/app/Animals'
import Show from '@/views/app/Animals/Show'
import RevertAdoption from '@/views/app/Animals/Show/components/AdoptionsCard/Actions'
import { Route, useRouteMatch } from 'react-router-dom'
import petReducer, { INITIAL_STATE } from '@/reducers/pet'

function PetsRoutes() {
  const { path } = useRouteMatch()
  const [state, dispatch] = useReducer(petReducer, INITIAL_STATE)

  return (
    <div>
      <Route path={`${path}`} exact>
        <List title="Petis - Parceiros / Pets" />
      </Route>
      <petContext.Provider value={{ state, dispatch }}>
        <Route path={`${path}/:id`}>
          <Show title="Petis - Parceiros / Histórico do pet" />
        </Route>
        <Route path={`${path}/:id/adoptions/:adoptionId/revert`}>
          <RevertAdoption title="Petis - Parceiros / Histórico de adoções / Reverter adoção" />
        </Route>
      </petContext.Provider>
    </div>
  )
}

export default PetsRoutes
